// frontend/geopolitikia/src/components/Popups.jsx
import React from 'react';
import {
  FileText,
  Shield,
  Swords,
  MapPin,
  User,
  Zap,
  Users
} from "lucide-react";
import Journal from "./Journal";
import Nucleaire from "./Nucleaire";
import Boutton from "./Button.jsx";
import Decret from "./Decret";

const Popups = ({ actions, setGameState, gameState, setActions, setMessage, message, setLoading, setPreviousArticles, previousArticles, setShowNewspaperPopup, showArchivePopup, setShowArchivePopup, selectedYear, setSelectedYear, sortedYears, showNuclear, setShowNuclear, setGuerres, setChatStatus, showNewspaperPopup, isMulti = false, submitMultiTurn = null }) => {
  const maxYear = Math.max(...previousArticles.map(article => article.year));
  const articleLast = previousArticles.filter(article => article.year === maxYear);
  const playerCountry = gameState?.joueur?.short_name;

  return (
    <>
      {actions && actions.length > 0 && (
        <Decret
          actions={actions}
          setGameState={setGameState}
          gameState={gameState}
          setActions={setActions}
          setMessage={setMessage}
          message={message}
          setLoading={setLoading}
          setPreviousArticles={setPreviousArticles}
          previousArticles={previousArticles}
          setShowNewspaperPopup={setShowNewspaperPopup}
          onClose={() => setActions([])}
          setGuerres={setGuerres}
          setChatStatus={setChatStatus}
          isMulti={isMulti}
          submitMultiTurn={submitMultiTurn}
        />)}
      {showNewspaperPopup && (
        <>
          <Journal
            title={`Journal de l\'année ${articleLast[0]?.year}`}
            articles={previousArticles.filter(article => article.year === articleLast[0]?.year)}
            onClose={() => {
              setShowNewspaperPopup(false);
              setShowArchivePopup(false);
              setSelectedYear(null);
            }}
            backChoice={() => {
              setShowNewspaperPopup(false);
              setShowArchivePopup(true);
              setSelectedYear(null);
            }}
            setShowArchivePopup={setShowArchivePopup}
            setSelectedYear={setSelectedYear}
          />
        </>)};

      {showArchivePopup && (
        <div className="popup-overlay">
          <div className="popup-content custom-scrollbar" style={{ maxHeight: '90vh', overflow: 'hidden' }}>
            <div className="min-h-4 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden flex flex-col" style={{ maxHeight: '90vh' }}>
              {/* Header fixe */}
              <div className="relative z-10 p-4 border-b border-slate-700/50 backdrop-blur-sm bg-slate-900/80 flex-shrink-0">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg">
                      <FileText className="w-6 h-6" />
                    </div>
                    <div>
                      <h1 className="text-xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                        REVUE DE PRESSE
                      </h1>
                      <p className="text-sm text-slate-400">ARCHIVES SYNAPSE NEWS</p>
                    </div>
                  </div>
                  <div className="text-right text-sm text-slate-400">
                    <Boutton
                      text="x FERMER"
                      onClick={() => setShowArchivePopup(false)}
                      text_after="← Retour"
                      delay={0}
                      variant="red"
                    />
                  </div>
                </div>
              </div>

              {!selectedYear ? (
                <div className="flex-1 overflow-y-auto custom-scrollbar p-6">
                  <div className="mb-4">
                    <h3 className="text-white text-lg font-semibold mb-2">Choisissez une année :</h3>
                    <p className="text-slate-400 text-sm">
                      {sortedYears.length} année{sortedYears.length > 1 ? 's' : ''} disponible{sortedYears.length > 1 ? 's' : ''}
                    </p>
                  </div>

                  {/* Grille scrollable des années */}
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                    {sortedYears.map(year => {
                      const articlesCount = previousArticles.filter(a => a.year === year).length;
                      return (
                        <button
                          key={year}
                          onClick={() => setSelectedYear(year)}
                          className="group relative bg-gradient-to-br from-slate-800 to-slate-900 hover:from-blue-900 hover:to-purple-900 
                                   border border-slate-700 hover:border-blue-500 rounded-xl p-4 
                                   transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:shadow-blue-500/20"
                        >
                          <div className="flex flex-col items-center gap-2">
                            <div className="text-3xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                              {year}
                            </div>
                            <div className="text-xs text-slate-400 group-hover:text-blue-300 transition-colors">
                              📰 {articlesCount} article{articlesCount > 1 ? 's' : ''}
                            </div>
                          </div>

                          {/* Indicateur visuel pour l'année actuelle */}
                          {year === maxYear && (
                            <div className="absolute top-2 right-2">
                              <span className="flex h-3 w-3">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
                              </span>
                            </div>
                          )}
                        </button>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div className="flex-1 overflow-hidden">
                  <Journal
                    title={`Journal de l\'année ${selectedYear}`}
                    articles={previousArticles.filter(article => article.year === selectedYear)}
                    onClose={() => {
                      setShowNewspaperPopup(false);
                      setShowArchivePopup(false);
                      setSelectedYear(null);
                    }}
                    backChoice={() => {
                      setShowNewspaperPopup(false);
                      setShowArchivePopup(true);
                      setSelectedYear(null);
                    }}
                    setShowArchivePopup={setShowArchivePopup}
                    setSelectedYear={setSelectedYear}
                    playerCountry={playerCountry}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {showNuclear && (<Nucleaire gameState={gameState} onClose={() => setShowNuclear(false)} />)}

    </>
  );
};

export default React.memo(Popups);
